var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSandbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4444 0H1.55556C0.7 0 0 0.7 0 1.55556V7C0 7.85556 0.7 8.55556 1.55556 8.55556H12.4444C13.3 8.55556 14 7.85556 14 7V1.55556C14 0.7 13.3 0 12.4444 0ZM12.4444 4.66667H9.33333C9.33333 5.92667 8.26 7 7 7C5.74 7 4.66667 5.92667 4.66667 4.66667H1.55556V1.55556H12.4444V4.66667ZM9.33333 10.1111H14V12.4444C14 13.3 13.3 14 12.4444 14H1.55556C0.7 14 0 13.3 0 12.4444V10.1111H4.66667C4.66667 11.4022 5.70889 12.4444 7 12.4444C8.29111 12.4444 9.33333 11.4022 9.33333 10.1111Z",
    fill: "#BABFC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSandbox);
export default __webpack_public_path__ + "static/media/sandbox.887b25011766e14c487bda3767ecb508.svg";
export { ForwardRef as ReactComponent };